<template>
  <div class="course-living-float-btn-component"
       v-if="showCourseLivingEntrance"
       @click="handleConfirmClick"
  >
    <ym-img class="img"
            :src="require('@/assets/img/course/course_living_float_btn.png')"
            alt="进入教室"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { getCourseLivingFloatBtnInfo, getCourseLessonPLayUrl } from '@/services/course';
  import {
    locationHref,
    isAppWebView,
    handleRunAppFn,
  } from '@/utils';

  export default {
    name: 'CourseLivingFloatBtn',
    data() {
      return {
        list: [],
        showCourseLivingEntrance: false,
      };
    },
    computed: {
      message() {
        const titleText = this.list.length > 1 ? `你有${this.list.length}门课程正在直播` : '你有一门课程正在直播';
        const title = `<div class="course-living-promote-title">${titleText}</div>`;
        const messageText = this.list.length > 1 ? '进入课表查看感兴趣的课程' : this.list[0].course.title;
        const message = `<div class="course-living-promote-message">${messageText}</div>`;
        return `${title}${message}`;
      },
      confirmButtonText() {
        return this.list.length > 1 ? '立即查看' : '进入教室';
      },
    },
    methods: {
      ...mapActions([
        'toggleCourseLivingEntrance',
      ]),
      async getCourseLivingFloatBtnInfo() {
        const data = await getCourseLivingFloatBtnInfo();
        this.list = data.list;
        if (this.list.length === 0) return;
        this.handleMessageBox();
      },
      handleConfirmClick() {
        if (this.list.length === 1) {
          this.handleCourseLivingUrl(this.list[0].course.id, this.list[0].lessonId);
          return;
        }
        const route = { name: 'MySchedule' };
        this.$router.push(route);
      },
      handleCancelClick() {
        this.showCourseLivingEntrance = true;
        this.toggleCourseLivingEntrance(true);
      },
      async handleCourseLivingUrl(courseId, lessonId) {
        const data = await getCourseLessonPLayUrl(courseId, lessonId);
        if (data.action === 'location') {
          if (isAppWebView()) {
            handleRunAppFn('lessonPlaySuccess', { courseId, lessonId });
          } else {
            locationHref(data.originUrl);
          }
          return;
        }
        this.$router.push({ name: 'ClassRoomDetail', query: { courseId, lessonId } });
      },
      handleMessageBox() {
        const message = `<span class="message">${this.message}</span>`;
        this.$dialog.confirm({
          title: '上课提醒',
          message,
          confirmButtonText: this.confirmButtonText,
          cancelButtonText: '稍后查看',
          closeOnClickOverlay: false,
        }).then(() => {
          this.handleConfirmClick();
        }).catch(() => {
          this.handleCancelClick();
        });
      },
    },
    created() {
      this.getCourseLivingFloatBtnInfo();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @living-float-btn-width: 160px;
  .course-living-float-btn-component {
    position: fixed;
    z-index: @z-index-large;
    left: 50%;
    margin-left: 750/2 - @living-float-btn-width - @size-base;
    bottom: 300px;
    width: 162px;
    height: 162px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .img {
      width: 100%;
      height: 100%;
    }
  }

</style>
